import BaseRequest from './BaseRequest';

export default class CustomerFormSubmissions extends BaseRequest {
    /**
     * CustomerFormSubmissions constructor
     *
     * @param {string} requestMode
     * @param {string} providerId
     * @param {string} customerId
     * @param {boolean} auth
     * @param {boolean} fowardRequest
     */
    constructor(
        requestMode = 'customer',
        providerId = '',
        customerId = '',
        auth = true,
        fowardRequest = false,
    ) {
        super(requestMode, providerId, customerId, auth, fowardRequest);
        this.setClassName('CustomerFormSubmissions');
        this.setEndpoint('customer_form_submissions');
    }
}
